import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { ProblemSection } from './components/ProblemSection';
import { RitualSection } from './components/RitualSection';
import { GallerySection } from './components/GallerySection';
import { TargetSection } from './components/TargetSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { LocationSection } from './components/LocationSection';
import { PromiseSection } from './components/PromiseSection';
import { CTASection } from './components/CTASection';
import { PhrasesSection } from './components/PhrasesSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { ServicesSection } from './components/ServicesSection';
import { RecentBookingToast } from './components/RecentBookingToast';
export function App() {
  return <div className="min-h-screen bg-delux-bg text-delux-body selection:bg-delux-gold selection:text-delux-bg" data-id="element-0">
      <Header data-id="element-1" />
      <RecentBookingToast data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <GallerySection data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <StorySection data-id="element-7" />
        <ProblemSection data-id="element-8" />
        <RitualSection data-id="element-9" />
        <TargetSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <LocationSection data-id="element-12" />
        <PromiseSection data-id="element-13" />
        <CTASection data-id="element-14" />
        <PhrasesSection data-id="element-15" />
        <FAQSection data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
    </div>;
}